import script from "./pulse-mention-hint.vue?vue&type=script&setup=true&lang=ts"
export * from "./pulse-mention-hint.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__